import React from "react";
import RecipeShared from "../Shared/recipe-shared";
import RecipeList from "../../recipes-list";
import RecipeHeader from "./recipe-header";

import { Container, Row } from "react-bootstrap";

function Recipes() {
  return (
    <div>
      <RecipeHeader />
      <section id="recipes" className="home-section text-center">
        <Container>
          <Row>
            {RecipeList.map((element) => {
              return (
                <RecipeShared
                  id={element.id}
                  key={element.id}
                  imageLink={element.imageLink}
                  title={element.title}
                  colSize={3}
                  mdSize={3}
                  smSize={6}
                  xsSize={6}
                  color="black"
                />
              );
            })}
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default Recipes;
